import React from 'react';
import { 
  Wheat, 
  Croissant, 
  CakeSlice, 
  Sandwich, 
  Snowflake, 
  Refrigerator, 
  Coffee, 
  ShoppingBasket, 
  Gift,
  EggFried,
  Vegan,
  WheatOff,
  Dessert,
  CircleStar
} from 'lucide-react';
import './CategoryMenu.css';

const CategoryMenu = ({ categories, selectedCategory, onCategorySelect }) => {
  const getIcon = (iconName) => {
    const iconProps = { size: 24 };
    
    switch(iconName) {
      case 'Wheat': return <Wheat {...iconProps} />;
      case 'Croissant': return <Croissant {...iconProps} />;
      case 'CakeSlice': return <CakeSlice {...iconProps} />;
      case 'Dessert': return <Dessert {...iconProps} />;
      case 'CircleStar': return <CircleStar {...iconProps} />;
      case 'Sandwich': return <Sandwich {...iconProps} />;
      case 'Snowflake': return <Snowflake {...iconProps} />;
      case 'Refrigerator': return <Refrigerator {...iconProps} />;
      case 'LeafyGreen': return <Coffee {...iconProps} />;
      case 'ShoppingBasket': return <ShoppingBasket {...iconProps} />;
      case 'Gift': return <Gift {...iconProps} />;
      case 'Multi-Aptos': 
        return (
          <div className="multi-icons">
            <EggFried {...iconProps} />
            <Vegan {...iconProps} />
            <WheatOff {...iconProps} />
          </div>
        );
      default: return <Wheat {...iconProps} />;
    }
  };

  const getShortName = (name) => {
    // Now we have more space, let's show full names
    return name;
  };

  return (
    <div className="category-menu">
      {categories.map(category => (
        <button
          key={category.id}
          className={`category-btn ${selectedCategory === category.id ? 'active' : ''}`}
          style={{
            borderLeftColor: category.color,
            ...(selectedCategory === category.id ? { outline: `2px solid ${category.color}` } : {})
          }}
          onClick={() => onCategorySelect(category.id)}
        >
          <span
            className="category-icon"
            style={{ color: category.color }}
          >
            {getIcon(category.icon)}
          </span>
          <span className="category-name">{getShortName(category.name)}</span>
        </button>
      ))}
    </div>
  );
};

export default CategoryMenu;